<template>
    <v-footer padless> <!-- Makes a footer element to describe the quantity names-->
        <v-col class="text-center" cols="12">
            <v-card-text class="black--text pt-0">
                EUI - Energy delivered to a building divided by its area.
            </v-card-text>
            <v-card-text class="black--text pt-0">
                EUI Moving Average (EUIMA) - 12 month moving average for EUI data.
            </v-card-text>
            <v-card-text class="black--text pt-0">
                Building Total Load (BTL) - Total amount of energy that a building has consumed.
            </v-card-text>
            <v-card-text class="black--text pt-0">
                Energy Ratio (ER) - The energy produced divided by the energy consumed by a building.
            </v-card-text>
            <v-card-text class="black--text pt-0">
                Energy Ratio Moving Average (ERMA) - 12 month moving average for Energy Ratio data.
            </v-card-text>
            <v-card-text class="black--text pt-0">
                Cooling - The amount of cooling energy used or created.
            </v-card-text>
            <v-card-text class="black--text pt-0">
                PV - The amount of photovoltaic energy created.
            </v-card-text>
        </v-col>
    </v-footer>
</template>

<script>
export default {}
</script>
